// 客户端插件：初始化 APP 环境
// .client.js 后缀表示只在客户端运行
import '@/utils/appEnv'

export default defineNuxtPlugin(() => {
  // 插件加载后，appEnv.js 的初始化代码已经执行
  if (process.env.NODE_ENV === 'development') {
    console.log('%c[Plugin] APP环境插件已加载', 'color: #9C27B0; font-weight: bold;')
  }
})

